import axios from 'axios';

// Base da URL: https://api.themoviedb.org/3/
// https://api.themoviedb.org/3/movie/now_playing?api_key=1ad71e78a610f1217e0b68dad3f1fa85

const api = axios.create({
  baseURL: 'https://api.themoviedb.org/3/',
});

export default api;
